import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { trackPageview, setTrackToken } from "../auth/track";

// Privacy-friendly page-view beacon. It records only the in-app route (hash
// path) and, when signed in, attributes the visit to the account. Views are
// QUEUED and flushed in batches by the tracker (src/auth/track.js) so moving
// around the app makes far fewer network calls. Errors are always swallowed —
// tracking must never affect the experience.
export default function Analytics() {
  const location = useLocation();
  const { token } = useAuth();

  // Keep the tracker's token current so queued batches attribute correctly.
  useEffect(() => {
    setTrackToken(token);
  }, [token]);

  useEffect(() => {
    trackPageview(location.pathname || "/", document.referrer || "");
  }, [location.pathname]);

  return null;
}
